import { render, staticRenderFns } from "./TpvAuth.vue?vue&type=template&id=dd66723e"
import script from "./TpvAuth.vue?vue&type=script&lang=js"
export * from "./TpvAuth.vue?vue&type=script&lang=js"
import style0 from "./TpvAuth.vue?vue&type=style&index=0&id=dd66723e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports